import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../../app/firebase';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchLegalPages,
  selectLegalPages,
  selectLegalPagesLoading,
  selectLegalPageError,
} from '../../../features/legalPages/legalPagesSlice';
import AdminLegalPages from './adminLegalPages';

export default function AdminLegalPagesContainer() {
  const dispatch = useDispatch();
  const [checkingAdmin, setCheckingAdmin] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const pages = useSelector(selectLegalPages);
  const loading = useSelector(selectLegalPagesLoading);
  const error = useSelector(selectLegalPageError);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setCheckingAdmin(true);
      setIsAdmin(false);
      if (!user) {
        setCheckingAdmin(false);
        return;
      }
      try {
        const token = await user.getIdTokenResult(true);
        setIsAdmin(!!token.claims.admin);
      } finally {
        setCheckingAdmin(false);
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (isAdmin) {
      dispatch(fetchLegalPages());
    }
  }, [dispatch, isAdmin]);

  const handleRefresh = () => {
    dispatch(fetchLegalPages());
  };

  if (checkingAdmin) return <div style={{ padding: 16 }}>Checking admin rights…</div>;
  if (!isAdmin) return <div style={{ padding: 16 }}>403 — Admin access only</div>;

  return (
    <AdminLegalPages
      pages={pages}
      loading={loading}
      error={error}
      onRefresh={handleRefresh}
    />
  );
}
